import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { LoyaltyProgramHelper } from '@rd/helpers/loyalty-program.helper';
import { LoyaltyProgramCategory } from '@rd/types';

@Component({
  selector: 'rd-tcv2-loyalty-programs-category-filter',
  templateUrl: './loyalty-programs-category-filter.component.html',
  styleUrls: ['./loyalty-programs-category-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TcV2LoyaltyProgramsCategoryFilterComponent {
  @HostBinding('class.rd-tcv2-loyalty-programs-category-filter')
  componentClass = true;
  @Input() category: LoyaltyProgramCategory | 'all';
  @Input() categoryOptions: (LoyaltyProgramCategory | 'all')[];
  @Output() categoryChange = new EventEmitter<LoyaltyProgramCategory | 'all'>();

  constructor(private loyaltyProgramHelper: LoyaltyProgramHelper) {}

  activeCategory(categoryOption: LoyaltyProgramCategory | 'all'): boolean {
    return categoryOption === this.category;
  }

  categoryChanged(category: LoyaltyProgramCategory | 'all'): void {
    this.categoryChange.emit(category);
  }

  categoryTranslationKey(
    categoryOption: LoyaltyProgramCategory | 'all',
  ): string {
    return this.loyaltyProgramHelper.categoryTranslationKey(categoryOption);
  }
}
